import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import ToolTip from "../common/models/buttons/ToolTip";
import { fetchOpenPOAlertsCount } from "../common/PoIssuesDashboard/poAlertsAPI";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
//svg icons
import { ReactComponent as DashboardIcon } from "./icons/dashboard.svg";
import { ReactComponent as PoIcon } from "./icons/po.svg";
// import { ReactComponent as LineIcon } from "./icons/line.svg";
import { ReactComponent as BatchIcon } from "./icons/batch.svg";
import { ReactComponent as TeamMembers } from "./icons/TeamMembers.svg";
// import { ReactComponent as ScheduleIcon } from "./icons/schedule.svg";
import { ReactComponent as GrnIcon } from "./icons/grn.svg";
import { ReactComponent as AuditIcon } from "./icons/audit.svg";
import { ReactComponent as UsersIcon } from "./icons/users.svg";
import { ReactComponent as CompanyIcon } from "./icons/company.svg";
import { ReactComponent as QualityEventIcon } from "./icons/QualityEventIcon.svg";
// import { ReactComponent as ProjectDashbaordIcon } from "./icons/projectDashboard.svg";
// import { ReactComponent as AnalyticsIcon } from "./icons/Analytics.svg";
// import { ReactComponent as IntegrationsIcon } from "./icons/Integrations.svg";
// import { ReactComponent as PerformanceIcon } from "./icons/Performance.svg";
// import { ReactComponent as ProjectReportsIcon } from "./icons/ProjectReports.svg";
// import { ReactComponent as ReportsIcon } from "./icons/Reports2Icon.svg";
// import { ReactComponent as LineItemsIcon } from "./icons/LineItemsIcon.svg";
// import { ReactComponent as BatchItemsIcon } from "./icons/BatchItemsIcon.svg";
import { ReactComponent as DeliveryScheduleIcon } from "./icons/DeliveryScheduleIcon.svg";
import { ReactComponent as ForecastScheduleIcon } from "./icons/forecastScheduleIcon.svg";
// import { ReactComponent as SiteAndResources } from "./icons/sitesAndResources.svg";
// import { navList } from './Navgiation';
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import BuildIcon from "@material-ui/icons/Build";
// import schrockenMiniLogo from '../../resources/images/logoMini.png';
// import schrockenLogo from "../../../../resources/images/Schrocken-Logo-Dark.png";
import collabrixLogo from "../../../../resources/images/collabrix-logo.svg";

// import AccessTimeIcon from "@material-ui/icons/AccessTime"; // Example icon for Pending Items
// import { ReactComponent as TaskIcon } from "./icons/TasksIcon.svg";
// import ImportContactsTwoToneIcon from "@material-ui/icons/ImportContactsTwoTone";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";

import { ReactComponent as Analytics } from "./sideBarIcons/Analytics.svg";
import { ReactComponent as BatchExecution } from "./sideBarIcons/BatchExecution.svg";
import { ReactComponent as CDMOs } from "./sideBarIcons/CDMOs.svg";
import { ReactComponent as Collaboration } from "./sideBarIcons/Collaboration.svg";
import { ReactComponent as Configuration } from "./sideBarIcons/Configuration.svg";
import { ReactComponent as DeliverySchedules } from "./sideBarIcons/DeliverySchedules.svg";
import { ReactComponent as Forecasting } from "./sideBarIcons/Forecasting.svg";
import { ReactComponent as GoodsReceipts } from "./sideBarIcons/goodsReceipt.svg";
import { ReactComponent as GenealogyReport } from "./sideBarIcons/GenealogyReport.svg";
import { ReactComponent as Inventory } from "./sideBarIcons/Inventory.svg";
import { ReactComponent as ManageRoles } from "./sideBarIcons/ManageRoles.svg";
import { ReactComponent as ManageUsers } from "./sideBarIcons/ManageUsers.svg";
import { ReactComponent as Materials } from "./sideBarIcons/Materials.svg";
import { ReactComponent as Notifications } from "./sideBarIcons/Notifications.svg";
import { ReactComponent as OrganizationProfile } from "./sideBarIcons/OrganizationProfile.svg";
import { ReactComponent as POFulfillment } from "./sideBarIcons/POFulfilment.svg";
import { ReactComponent as Products } from "./sideBarIcons/Products.svg";
import { ReactComponent as PurchaseOrder } from "./sideBarIcons/PurchaseOrder.svg";
import { ReactComponent as Quality } from "./sideBarIcons/Quality.svg";
import { ReactComponent as RMPMDeliveries } from "./sideBarIcons/RMPMDeliveries.svg";
import { ReactComponent as SASLReports } from "./sideBarIcons/SASLReports.svg";
import { ReactComponent as SAPIcon } from "./sideBarIcons/SAP-Icon.svg";
import { ReactComponent as UserManagement } from "./sideBarIcons/UserManagement.svg";
import { ReactComponent as InactivePOsIcon } from "./sideBarIcons/InactivePOs.svg";
import { ReactComponent as manageReasonCodes } from "./sideBarIcons/Materials.svg";
import { ReactComponent as materialDetails } from "./sideBarIcons/Materials.svg";
import { ReactComponent as brandDetails } from "./sideBarIcons/Products.svg";
import { ReactComponent as sponsorNetwork } from "./sideBarIcons/Group.svg";
import { Divider } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  listDiv: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    // paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "91%",
  },
  toolTip: {
    fontSize: "0.875rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
    },
  },
  activePath: {
    background:
      "linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box",
    borderRadius: 12,
    opacity: 1,
    color: "#ffffff",
    // [theme.breakpoints.down('md')]: {
    //   paddingBottom: '0.25rem',
    //   paddingTop: '0.25rem',
    // },
  },
  activeParentNav: {
    background:
      "linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box",
    borderRadius: 12,
    opacity: 1,
    color: "#ffffff",
    "& .MuiListItemIcon-root": {
      color: "#ffffff",
    },
    "& .MuiListItemText-primary": {
      color: "#ffffff",
    },
  },
  inactivePath: {
    // [theme.breakpoints.down('md')]: {
    //   paddingBottom: '0.25rem',
    //   paddingTop: '0.25rem',
    // },
  },
  listButton: {
    marginTop: 2,
    "&:hover": {
      borderRadius: 12,
    },
    [theme.breakpoints.down("lg")]: {
      marginTop: 0,
    },
  },
  listItemIcon: {
    // minWidth: 50,
    marginRight: "20px",
    width: "20px",
    alignSelf: "center",
    justifyContent: "center",
    minWidth: "20px",
  },
  dspNone: {
    display: "none",
  },
  listItemPadding: {
    // [theme.breakpoints.down('md')]: {
    //   paddingBottom: '0.25rem',
    //   paddingTop: '0.25rem',
    // },
  },
  manage: {
    fontSize: "0.875rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
    },
  },
}));

const SideBarIndex = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { sideBarOpen, handleDrawerOpen } = props;

  // Get sidebar state from Redux
  const reduxSideBarOpen = useSelector((state) => state.pcmp.common.uiState.sideBarOpen);

  //   const [projectOpen, setProjectOpen] = useState(false);
  //   const [integrationOpen, setIntegrationOpen] = useState(false);
  //   const [reportsOpen, setReportsOpen] = useState(false);
  //   const [performanceOpen, setPerformanceOpen] = useState(false);
  //   const [openScheduleAgreements, setOpenSA] = useState(false);
  //---------------------------------

  const [userManagement, setUserManagement] = useState(false);
  const [configuration, setConfiguration] = useState(false);
  const [collabration, setCollabration] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  // Helper function to check if current route belongs to a parent nav
  const isRouteActive = (routes) => {
    return routes.some(route => location.pathname.includes(route));
  };

  // Define route mappings for each parent navigation
  const userManagementRoutes = ['rolesandaccess', 'teamMembers', 'managemembers'];
  const configurationRoutes = ['orgprofile', 'CMOs', 'products', 'branddetails', 'sponsornetwork', 'managereasoncodes', 'materialdetails'];
  // 'goodsReceipt' (BCM-898) and 'sap-audit' come from this branch; BCM-897 only
  // added 'poAlerts'. Both route lists keep every entry from both sides.
  const collaborationRoutes = ['purchaseorderManagement', 'inactivePOs', 'poAlerts', 'schedule agreements', 'fgBatches', 'inventoryStatus', 'goodsReceipt'];
  const analyticsRoutes = ['pofulfilmentdashboard', 'genealogyReports', 'sa-audit-reports', 'sap-audit'];

  // Declared here rather than further down because the PO Alerts count effect
  // below depends on it.
  let screensAccess = useSelector((state) => {
    return state.pcmp.common.accessControl.screensAccess.data;
  });

  // BCM-897: open-alert count on the PO Alerts icon. Guarded on exactly the same
  // conditions as the nav item itself, so neither a CMO session nor a sponsor
  // role without access to the screen makes the request. Kept as a derived
  // boolean so the dependency is stable — screensAccess is a fresh object each
  // render and would otherwise re-fire the effect.
  const hasPoAlertsAccess =
    screensAccess?.poAlertDashboard?.screenAccess === true;
  const [openAlertCount, setOpenAlertCount] = useState(0);

  useEffect(() => {
    if (localStorage?.collabType === "CMO") return undefined;
    if (!hasPoAlertsAccess) return undefined;
    let cancelled = false;
    fetchOpenPOAlertsCount().then((count) => {
      if (!cancelled) setOpenAlertCount(count);
    });
    return () => {
      cancelled = true;
    };
  }, [hasPoAlertsAccess]);

  // Check if parent navs should be highlighted
  const isUserManagementActive = isRouteActive(userManagementRoutes);
  const isConfigurationActive = isRouteActive(configurationRoutes);
  const isCollaborationActive = isRouteActive(collaborationRoutes);
  const isAnalyticsActive = isRouteActive(analyticsRoutes);

  const handleSideBarClick = (subMenu) => {
    handleDrawerOpen();

    // If needed, subMenu handling below
    // if (subMenu === "projectsdashboard") {
    //   setProjectOpen(!projectOpen);
    //   // props.handleDrawerClose()
    // }
    // if (subMenu === "Analytics") {
    //   setIsAnalyticsOpen(!isAnalyticsOpen);
    // }
    // if (subMenu === "Integrations") {
    //   setIntegrationOpen(!integrationOpen);
    // }
    // if (subMenu === "Reports") {
    //   setReportsOpen(!reportsOpen);
    // }
    // if (subMenu === "Performance") {
    //   setPerformanceOpen(!performanceOpen);
    // }
    // if (subMenu === "ScheduleAgreements") {
    //   setOpenSA(!openScheduleAgreements);
    //   }

    ///
    if (subMenu === "userManagement") {
      setUserManagement(!userManagement);
    }
    if (subMenu === "configuration") {
      setConfiguration(!configuration);
    }
    if (subMenu === "collaboration") {
      setCollabration(!collabration);
    }
    if (subMenu === "analytics") {
      setAnalytics(!analytics);
    }
  };

  useEffect(() => {
    if (!sideBarOpen) {
      //   setProjectOpen(false);
      //   setIsAnalyticsOpen(false);
      //   setIntegrationOpen(false);
      //   setReportsOpen(false);
      //   setPerformanceOpen(false);
      //   setOpenSA(false);
      setUserManagement(false);
      setConfiguration(false);
      setCollabration(false);
      setAnalytics(false);
    }
  }, [sideBarOpen]);

  return (
    <div style={{ width: !sideBarOpen && "50px" }} className={classes.listDiv}>
      <div>
        <List>
          {screensAccess !== undefined &&
            (screensAccess?.manageRoleAndAccess?.screenAccess === true ||
              screensAccess?.manageTeamMembers?.screenAccess === true) && (
              <NavigationItem
                routeName={"User Management"}
                NavIcon={UserManagement}
                handleDrawerClose={() => handleSideBarClick("userManagement")}
                selected={isUserManagementActive}
                className={
                  isUserManagementActive ? classes.activeParentNav : ""
                }
              />
            )}
          {userManagement && (
            <div style={{ paddingLeft: 30, marginTop: 12 }}>
              {screensAccess !== undefined &&
                screensAccess?.manageRoleAndAccess?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Manage Roles"}
                    route="rolesandaccess"
                    NavIcon={ManageRoles}
                  />
                )}

              {screensAccess !== undefined &&
                screensAccess?.manageTeamMembers?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Manage Users"}
                    route="teamMembers"
                    NavIcon={ManageUsers}
                  />
                )}

              {/* {localStorage?.collabType !== "CMO" && (
                <NavigationItem
                  routeName={"Network Users"}
                  route="managemembers"
                  NavIcon={UsersIcon}
                />
              )} */}
            </div>
          )}

          {screensAccess !== undefined &&
            screensAccess?.manageOrgProfile?.screenAccess && (
              <NavigationItem
                routeName={"Configuration"}
                NavIcon={Configuration}
                handleDrawerClose={() => handleSideBarClick("configuration")}
                selected={isConfigurationActive}
                className={isConfigurationActive ? classes.activeParentNav : ""}
              />
            )}
          {configuration && (
            <div style={{ paddingLeft: 30, marginTop: 12 }}>
              {screensAccess !== undefined &&
                screensAccess?.manageOrgProfile?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Organization Profile"}
                    route="orgprofile"
                    NavIcon={OrganizationProfile}
                  />
                )}
              {screensAccess !== undefined &&
                localStorage?.collabType !== "CMO" &&
                screensAccess?.manageCmoDashboard?.screenAccess === true && (
                  <NavigationItem
                    // routeName={"CMO/CDMOs"}
                    routeName={"CMOs"}
                    route="CMOs"
                    NavIcon={CDMOs}
                  />
                )}
              {screensAccess !== undefined &&
                screensAccess?.manageProducts?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Product Details"}
                    route="products"
                    NavIcon={Products}
                  />
                )}
              {screensAccess !== undefined &&
                screensAccess?.manageBrandDetails?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Brand Details"}
                    route="branddetails"
                    NavIcon={brandDetails}
                  />
                )}
              {screensAccess !== undefined &&
                screensAccess?.manageSponsorNetwork?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Sponsor Network"}
                    route="sponsornetwork"
                    NavIcon={sponsorNetwork}
                  />
                )}
              {/* {screensAccess !== undefined &&
                screensAccess?.manageOrgProfile?.screenAccess === true && ( */}
              {/* <NavigationItem
                routeName={"Materials"}
                // route="orgprofile"
                NavIcon={Materials}
              /> */}
              {/* )} */}
              {/* {screensAccess !== undefined &&
                screensAccess?.manageOrgProfile?.screenAccess === true && ( */}
              {/* <NavigationItem
                routeName={"Manage Reason Codes"}
                route="managereasoncodes"
                NavIcon={manageReasonCodes}
              /> */}
              {/* )} */}
              {/* {screensAccess !== undefined &&
                screensAccess?.manageOrgProfile?.screenAccess === true && ( */}
              {/* <NavigationItem
                routeName={"Material Details"}
                route="materialdetails"
                NavIcon={materialDetails}
              /> */} 
              {/* )} */}
            </div>
          )}

          {screensAccess !== undefined &&
            (screensAccess?.forecastScheduleDetails?.screenAccess === true ||
              screensAccess?.poManagementDashboard?.screenAccess === true ||
              screensAccess?.grnReceipts?.screenAccess === true ||
              screensAccess?.scheduleAgreements?.screenAccess === true ||
              screensAccess?.deliverySchedule?.screenAccess === true) && (
              <NavigationItem
                routeName={"Collaboration"}
                NavIcon={Collaboration}
                handleDrawerClose={() => handleSideBarClick("collaboration")}
                selected={isCollaborationActive}
                className={isCollaborationActive ? classes.activeParentNav : ""}
              />
            )}

          {collabration && (
            <div style={{ paddingLeft: 30, marginTop: 12 }}>
              {/* {screensAccess !== undefined &&
                screensAccess?.forecastScheduleDetails?.screenAccess ===
                  true && (
                  <NavigationItem
                    routeName={"Forecasting"}
                    route="forecastSchedule"
                    NavIcon={Forecasting}
                  />
                )} */}
              {/* {screensAccess !== undefined &&
                screensAccess?.poManagementDashboard?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Purchase Orders"}
                    route="purchaseorders"
                    NavIcon={PurchaseOrder}
                  />
                )} */}
              {screensAccess !== undefined &&
                screensAccess?.poCollaborationDashboard?.screenAccess ===
                  true && (
                  <NavigationItem
                    routeName={"Purchase Orders"}
                    route="purchaseorderManagement"
                    NavIcon={PoIcon}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )}

              {screensAccess !== undefined &&
                screensAccess?.deliveredDeletedPO?.screenAccess ===
                  true && (
                  <NavigationItem
                    routeName={"Delivered/Deleted POs"}
                    route="inactivePOs"
                    NavIcon={InactivePOsIcon}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )}

              {/* BCM-897: PO Alerts dashboard — BMS (sponsor) side only. This
                  sidebar is shared with the CMO layout, and the /poAlerts route
                  is registered in PharmaCoRoutes only, so the CMO guard is
                  required or a CMO user would get a dead link. */}
              {/* Role-based screen access, same contract as every other screen
                  here. 'poAlertDashboard' must match the screen_variable seeded
                  in the `screens` table — until that row and its
                  screen_to_roles_mapping rows exist the key is absent from
                  getScreensAccess and the item stays hidden. Previously this was
                  ungated (collabType only), which showed PO Alerts to every
                  sponsor-side role. */}
              {localStorage?.collabType !== "CMO" &&
                screensAccess !== undefined &&
                screensAccess?.poAlertDashboard?.screenAccess === true && (
                  <NavigationItem
                    routeName={"PO Alerts"}
                    route="poAlerts"
                    NavIcon={ReportProblemOutlinedIcon}
                    badgeCount={openAlertCount}
                  />
                )}

              {/* {screensAccess !== undefined &&
                screensAccess?.grnReceipts?.screenAccess === true && (
                  <NavigationItem
                    routeName={"RM/PM deliveries"}
                    route="GRNReceipts"
                    NavIcon={RMPMDeliveries}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )} */}

              {/* {screensAccess !== undefined &&
                screensAccess?.scheduleAgreements?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Delivery Schedules"}
                    route="schedule agreements"
                    NavIcon={DeliverySchedules}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )} */}

              {screensAccess !== undefined &&
                screensAccess?.deliverySchedule?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Batch Execution"}
                    route="fgBatches"
                    NavIcon={BatchExecution}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )}

              {/* BCM-898 — Goods Receipt dashboard, placed after Batch Execution. */}
              {screensAccess !== undefined &&
                (screensAccess?.deliverySchedule?.screenAccess === true) && (
                  <NavigationItem
                    routeName={"Goods Receipt"}
                    route="goodsReceipt"
                    NavIcon={GoodsReceipts}
                  />
                )}

              {screensAccess !== undefined &&
               screensAccess?.inventoryReconciliationDashboard?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Inventory Status"}
                    route="inventoryStatus"
                    NavIcon={Inventory}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )}
              {/* <NavigationItem
                routeName={"Quality"}
                NavIcon={Quality}
                // handleDrawerClose={props.handleDrawerClose}
              /> */}
            </div>
          )}

          {screensAccess !== undefined &&
            screensAccess?.notificationsDashboard?.screenAccess === true && (
              <NavigationItem
                routeName={"Notifications"}
                route="notifications"
                NavIcon={Notifications}
                handleDrawerClose={props.handleDrawerClose}
              />
            )}

          {screensAccess !== undefined &&
            (screensAccess?.poFulfilmentDashboard?.screenAccess === true ||
              screensAccess?.genealogyReports?.screenAccess === true ||
              screensAccess?.batchHistoryReports?.screenAccess === true ||
              localStorage?.collabType !== "CMO") && (
              <NavigationItem
                routeName={"Analytics"}
                NavIcon={Analytics}
                handleDrawerClose={() => handleSideBarClick("analytics")}
                selected={isAnalyticsActive}
                className={isAnalyticsActive ? classes.activeParentNav : ""}
              />
            )}
          {analytics && (
            <div style={{ paddingLeft: 30, marginTop: 12 }}>
              {screensAccess !== undefined &&
                screensAccess?.poFulfilmentDashboard?.screenAccess === true &&
                localStorage?.collabType !== "CMO" && (
                  <NavigationItem
                    routeName={"PO Fulfilment"}
                    route="pofulfilmentdashboard"
                    NavIcon={POFulfillment}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )}

              {screensAccess !== undefined &&
                screensAccess?.genealogyReports?.screenAccess === true &&
                localStorage.collabType !== "CMO" && (
                  <NavigationItem
                    routeName={"Genealogy report"}
                    route="genealogyReports"
                    NavIcon={GenealogyReport}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )}

              {screensAccess !== undefined &&
                screensAccess?.batchHistoryReports?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Batch History Reports"}
                    route="sa-audit-reports"
                    NavIcon={SASLReports}
                    // handleDrawerClose={props.handleDrawerClose}
                  />
                )}

              {/* Pre-emptive Analysis dashboard — shown ONLY when the role's
                  screens-access config contains the ESDADashboard screen
                  (screen_variable: "ESDADashboard"). Assign it to the sponsor
                  admin / roles that should see it. */}
              {screensAccess !== undefined &&
                screensAccess?.ESDADashboard?.screenAccess === true && (
                  <NavigationItem
                    routeName={"Pre-emptive Analysis Dashboard"}
                    route="esda"
                    NavIcon={AuditIcon}
                  />
                )}
            </div>
          )}

          {/* {screensAccess !== undefined &&
            screensAccess?.dashboard?.screenAccess === true && (
              <NavigationItem
                routeName={"Dashboard"}
                route="dashboard"
                NavIcon={DashboardIcon}
                handleDrawerClose={props.handleDrawerClose}
              />
            )}
          {screensAccess !== undefined &&
            screensAccess?.execDashboard?.screenAccess === true && (
              <NavigationItem
                routeName={"Executive Dashboard"}
                route="executivedashboard"
                NavIcon={AssessmentOutlinedIcon}
                {...props}
              />
            )} */}

          {/* {screensAccess !== undefined &&
            screensAccess?.projectDashboard?.screenAccess === true && (
              <NavigationItem
                routeName={"Projects Dashboard"}
                route="projectsdashboard"
                NavIcon={ProjectDashbaordIcon}
                handleDrawerClose={() =>
                  handleSideBarClick("projectsdashboard")
                }
              />
            )}
          {projectOpen && (
            <div style={{ paddingLeft: 30, marginTop: 12 }}>
              {screensAccess !== undefined && (
                <NavigationItem
                  routeName={"Analytics"}
                  // route="analytics"
                  NavIcon={AnalyticsIcon}
                  // handleDrawerClose={props.handleDrawerClose}
                  handleDrawerClose={() => handleSideBarClick("Analytics")}
                  subSidebar={true}
                  selected={isAnalyticsOpen}
                />
              )}
              {isAnalyticsOpen && (
                <div>
                  <List>
                    <NavigationItem
                      routeName={"Milestone Tracking"}
                      // route="milestonetracking"
                      subSidebar={true}
                      // NavIcon={DescriptionOutlinedIcon}
                    />
                    <NavigationItem
                      routeName={"Critical Path Items"}
                      subSidebar={true}
                      // route="criticalpathitems"
                      // NavIcon={AccessTimeIcon}
                    />
                    <NavigationItem
                      routeName={"Pending Items"}
                      route="projectsdashboard/pendingitems"
                      subSidebar={true}
                      // NavIcon={AccessTimeIcon}
                    />
                    <NavigationItem
                      routeName={"Delayed Items"}
                      // route="delayeditems"
                      subSidebar={true}
                      // NavIcon={EventNoteIcon}
                    />
                    <NavigationItem
                      routeName={"FTE/Budget"}
                      route="projectsdashboard/FTE-Budget"
                      subSidebar={true}
                      // NavIcon={EventNoteIcon}
                    />
                  </List>
                </div>
              )}
              {screensAccess !== undefined && (
                <NavigationItem
                  routeName={"Integrations"}
                  // route="integrations"
                  NavIcon={IntegrationsIcon}
                  handleDrawerClose={() => handleSideBarClick("Integrations")}
                  subSidebar={true}
                  selected={integrationOpen}
                />
              )}
              {integrationOpen && (
                <div>
                  <List>
                    <NavigationItem
                      routeName={"MSE Dashboard"}
                      // route="msedashbaord"
                      subSidebar={true}
                    />
                    <NavigationItem
                      routeName={"QMS Dashboard"}
                      // route="qmsDashboard"
                      subSidebar={true}
                    />
                    <NavigationItem
                      routeName={"LIMS Dashboard"}
                      // route="limsDashboard"
                      subSidebar={true}
                    />
                    <NavigationItem
                      routeName={"Logistics Dashboard"}
                      // route="logisticsDashboard"
                      subSidebar={true}
                    />
                  </List>
                </div>
              )}
              {screensAccess !== undefined && (
                <NavigationItem
                  routeName={"Reports"}
                  // route="reportsPage"
                  NavIcon={AccessTimeIcon}
                  // NavIcon={ProjectReportsIcon}
                  handleDrawerClose={() => handleSideBarClick("Reports")}
                  subSidebar={true}
                  selected={reportsOpen}
                />
              )}
              {reportsOpen && (
                <div>
                  <List>
                    <NavigationItem
                      routeName={"Project Tracking Reports"}
                      // route="projectTrackingReports"
                      subSidebar={true}
                    />
                    <NavigationItem
                      routeName={"Batch Reports"}
                      // route="qmsDashboard"
                      subSidebar={true}
                    />
                    <NavigationItem
                      routeName={"Structured Data"}
                      route="projectsdashboard/structuredData"
                      subSidebar={true}
                      // handleDrawerClose={props.handleDrawerClose}
                    />
                  </List>
                </div>
              )}
              {screensAccess !== undefined && (
                <NavigationItem
                  routeName={"Performance"}
                  // route="performance"
                  NavIcon={PerformanceIcon}
                  handleDrawerClose={() => handleSideBarClick("Performance")}
                  subSidebar={true}
                  selected={performanceOpen}
                />
              )}
              {performanceOpen && (
                <div>
                  <List>
                    <NavigationItem
                      routeName={"Comments & Remarks"}
                      // route="qmsDashboard"
                      subSidebar={true}
                    />
                    <NavigationItem
                      routeName={"Time Gap"}
                      // route="structuredData"
                      subSidebar={true}
                    />
                  </List>
                </div>
              )}
            </div>
          )} */}

          {/* {screensAccess !== undefined &&
            screensAccess?.lineItems?.screenAccess === true && (
              <NavigationItem
                routeName={"Line Items"}
                route="lineitems"
                NavIcon={LineItemsIcon}
                handleDrawerClose={props.handleDrawerClose}
              />
            )}
          {screensAccess !== undefined &&
            screensAccess?.batchItems?.screenAccess === true && (
              <NavigationItem
                routeName={"Batch Items"}
                route="batches"
                NavIcon={BatchItemsIcon}
                handleDrawerClose={props.handleDrawerClose}
              />
            )} */}

          {/* {screensAccess !== undefined &&
            screensAccess.shortFalls.screenAccess === true && (
              <NavigationItem
                routeName={"Shortfall Reports"}
                route="shortFalls"
                NavIcon={DescriptionOutlinedIcon}
                {...props}
              />
            )} */}
          {/* {screensAccess !== undefined &&
            screensAccess.reports.screenAccess === true && (
              <NavigationItem
                routeName={"Reports"}
                route="reports"
                NavIcon={ReportsIcon}
                handleDrawerClose={props.handleDrawerClose}
              />
            )} */}

          {/* Quality Events added */}

          {/* <NavigationItem
            routeName={"Quality Events"}
            //route='quality events'
            route="quality events"
            NavIcon={QualityEventIcon}
            //NavIcon={QualityEventIcon}
            handleDrawerClose={props.handleDrawerClose}
          /> */}

          
          {screensAccess !== undefined &&
                screensAccess?.digitizationDashboardAWS?.screenAccess === true && (
            <NavigationItem
              routeName={"Digitization Dashboard"}
              route="digitizationdashboard"
              NavIcon={DescriptionOutlinedIcon}
              handleDrawerClose={props.handleDrawerClose}
            />
          )}
          
          {screensAccess !== undefined &&
                screensAccess?.operationsDashboard?.screenAccess === true && (


           <NavigationItem
              routeName={"Daily Operations Dashboard"}
              route="dailyoperationsdashboard"
              NavIcon={BuildIcon}
              handleDrawerClose={props.handleDrawerClose}
            />
            )}

             
        </List>
        {/* <Typography
          variant="body1"
          style={{ paddingTop: "0.2rem", fontWeight: 500 }}
          className={classes.manage}
        >
          Manage
        </Typography> */}
        <List>
          {/* <NavigationItem
            routeName={"Tasks Dashboard"}
            route="tasksDashboard"
            NavIcon={ImportContactsTwoToneIcon}
            handleDrawerClose={props.handleDrawerClose}
          /> */}

          {/* <NavigationItem
            routeName={"Network Users"}
            route="managemembers"
            NavIcon={UsersIcon}
          /> */}

          {/* <NavigationItem
            routeName={'Sites and resources'}
            route='sitesAndResources'
            NavIcon={SiteAndResources}
          /> */}

        </List>
        {/* <Typography
          variant="body1"
          style={{ paddingTop: "0.2rem", fontWeight: 500 }}
          className={classes.manage}
        >
          Manage
        </Typography> */}
      </div>

      <div>
        <Divider />
        {sideBarOpen === true && (
          <div>
            <img
              src={collabrixLogo}
              // src={sideBarOpen?schrockenLogo:schrockenMiniLogo}
              alt="logo_mini"
              style={{
                maxWidth: sideBarOpen ? "75%" : "100%",
                height: "auto",
              }}
            />
          </div>
        )}
        <div style={{ padding: sideBarOpen ? 8 : 0 }}>
          <Typography
            variant="caption"
            className={classes.type}
            style={{
              fontSize: sideBarOpen ? "0.63rem" : "0.54rem",
              display: sideBarOpen ? "none" : "initial",
              textAlign: "center",
              lineHeight: 1.1,
            }}
          >
            &#169; {new Date().getFullYear()}{" "}
            <br className={sideBarOpen ? classes.dspNone : null} />
            Collabrix Inc.
            <br className={sideBarOpen ? classes.dspNone : null} />
            All rights <br className={sideBarOpen ? classes.dspNone : null} />
            reserved.
          </Typography>
        </div>
      </div>
    </div>
  );
};

const NavigationItem = (props) => {
  const {
    routeName,
    route,
    NavIcon,
    handleDrawerClose,
    subSidebar,
    selected,
    className,
    badgeCount
  } = props;
  const location = useLocation();
  const matches = useMediaQuery("(min-height: 650px)");
  const classes = useStyles();
  let path = location.pathname.split("/");
  let currentPath = path[6];
  let currectSubPath = path[7];

  // Determine the class to apply
  const getItemClass = () => {
    // If a custom className is provided (for parent nav highlighting), use it
    if (className) {
      return className;
    }
    
    // If selected prop is provided, use activeParentNav class
    if (selected) {
      return classes.activeParentNav;
    }
    
    // Default route-based styling
    if (!subSidebar) {
      return currentPath === route ? classes.activePath : classes.inactivePath;
    } else {
      return currectSubPath
        ? `${currentPath}/${currectSubPath}` === route
          ? classes.activePath
          : classes.inactivePath
        : classes.inactivePath;
    }
  };

  const isActive = Boolean(selected || className || currentPath === route);

  const renderNavIcon = () => (
    <NavIcon
      fill={isActive ? "#ffffff" : "#313645"}
      style={{
        color: isActive ? "#ffffff" : "#313645",
        '--arrow-color': isActive ? "#313645" : "#ffffff"
      }}
    />
  );

  return (
    <ToolTip title={routeName} placement="right-start" arrow>
      <ListItem
        button
        className={getItemClass()}
        classes={{ button: classes.listButton }}
        component={route && Link}
        to={
          route
            ? `/${path[1]}/${path[2]}/${path[3]}/${path[4]}/${path[5]}/${route}`
            : `/${path[1]}/${path[2]}/${path[3]}/${path[4]}/${path[5]}/${currentPath}`
        }
        onClick={handleDrawerClose}
        // className={classes.listItemPadding}
        style={{
          paddingBottom: matches ? "8px" : "0.25rem",
          paddingTop: matches ? "8px" : "0.25rem",
        }}
      >
        <ListItemIcon classes={{ root: classes.listItemIcon }}>
          {/* Only a nav item that was given a count gets wrapped in a Badge —
              this component renders every sidebar row, so an unconditional
              wrapper would alter the markup of icons that need no badge. */}
          {NavIcon && (badgeCount > 0 ? (
            <Badge badgeContent={badgeCount} max={99} color="error">
              {renderNavIcon()}
            </Badge>
          ) : (
            renderNavIcon()
          ))}
        </ListItemIcon>
        <ListItemText
          primary={routeName}
          classes={{ primary: classes.toolTip }}
        />
      </ListItem>
    </ToolTip>
  );
};

export default SideBarIndex;
